import { render, staticRenderFns } from "./VipSelect.vue?vue&type=template&id=a24a3d6e&scoped=true&"
import script from "./VipSelect.vue?vue&type=script&lang=js&"
export * from "./VipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24a3d6e",
  null
  
)

export default component.exports